import { useState, useEffect } from 'react';

const useContactAttributes = () => {

  const [crumbsList, setCrumbsList] = useState([]);
  useEffect(() => {
    const getParams = window.connect.contact(function (contact) {
      console.log("contactId",contact.getContactId());
      console.log("original contact id",contact.getOriginalContactId());
      var contactAttributes = contact.getAttributes();
      var contactAttributesVal = Object.values(contactAttributes);
      const crumbsArray = [];
      for (let i = 0; i < contactAttributesVal.length; i++) {
        crumbsArray.push(contactAttributesVal[i]["value"])
      }
      const crumbs = contactAttributes["crumbs"]["value"];
      setCrumbsList(crumbs);
      return () => { getParams.unsubscribe() };
    });

  },
    []);
  return { crumbsList };
};

export default useContactAttributes;
